import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  selectInviteLoading,
  selectInviteModalIsOpen,
  inviteUserAsync,
  closeInviteModal,
  getTeamsAsync,
} from "../../../store/settings/teams/teamsSlice";
import { InviteUserSchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { Button, Modal, Input } from "djuno-design";
import { useCallback, useEffect } from "react";

const InviteUserModal = () => {
  const isOpen = useAppSelector(selectInviteModalIsOpen);
  const loading = useAppSelector(selectInviteLoading);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(InviteUserSchema),
  });

  const onSubmit = (data: any) => {
    dispatch(
      inviteUserAsync({
        // Name: data.name,
        Email: data.email,
      })
    ).then((action) => {
      if (action.type === "teams/invite/fulfilled") {
        handleOnClose();
        dispatch(getTeamsAsync({}));
      }
    });
  };

  const handleOnClose = useCallback(() => {
    reset();
    dispatch(closeInviteModal());
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      //   containerClassName="!items-start"
      title="Invite new user"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          {/* <Input
            label="What's their name?"
            inputProps={{ ...register("name") }}
            error={errors.name?.message}
            placeholder=""
          /> */}
          <Input
            label="What's their email address?"
            {...register("email")}
            error={errors.email?.message}
            placeholder=""
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            disabled={loading}
            type="submit"
            className="w-[160px]"
          >
            Add team member
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default InviteUserModal;
